import { type UseQueryOptions, type UseQueryResult, useQuery } from 'react-query';
import { QUERY_KEYS } from '@/utils/queryKeys';
import { useServices } from '@/components/Services';
import type { GetFilesArg, GetFilesResult } from '@/services/api/files';
import { isEmpty } from 'ramda';

export const useFiles = (
  filter: GetFilesArg | undefined = {},
  options: UseQueryOptions<GetFilesResult> = {},
): UseQueryResult<GetFilesResult> => {
  const { filesApiClient } = useServices();
  return useQuery({
    queryKey: QUERY_KEYS.files.filter(filter),
    queryFn: async ({ signal }) => await filesApiClient.get(filter, signal),
    enabled: !isEmpty(filter),
    onError: console.error,
    ...(options && options),
  });
};
